// prevent scroll lock on ios
// based on this solution https://github.com/ionic-team/ionic-v1/issues/155#issuecomment-411110252

const directive = {};

directive.y = 0;

directive.record = function(event) {
  directive.y = event.touches[0].clientY;
};

directive.check = function (event) {
  if (!event.cancelable) return;

  const top = event.touches[0].clientY;
  const scrollTop = event.currentTarget.scrollTop;
  const direction = (directive.y - top) < 0 ? 'up' : 'down';

  if (scrollTop === 0 && direction === 'up') {
    event.preventDefault();
    event.stopPropagation();
  } else if (scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.offsetHeight) && direction === 'down') {
    event.preventDefault();
    event.stopPropagation();
  }

  directive.y = top;
};

directive.bind = function (el, binding) {
  el.addEventListener('touchstart', directive.record);
  el.addEventListener('touchmove', directive.check);
};

directive.unbind = function (el, binding) {
  el.removeEventListener('touchstart', directive.record);
  el.removeEventListener('touchmove', directive.check);
};

export default directive;
